
<template>
  <b-modal
    id="mobile-how-modal"
    v-model="show"
    ok-only
    centered
    size="lg"
    footer-class="d-none"
    header-class="d-none"
  >
    <div class="mobile-modal-top bg-secondary">
      <div class="row">
        <div class="col-8">
          <h3>איך זה עובד</h3>
        </div>
        <div @click="show=false" class="close-icon col-4 text-left">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>  
    <div class="how-to-inner-content">
        <p>הנקדן נועד להוסיף ניקוד אוטומטי למלל חופשי.</p>
        <p>הנקדן מיועד לטקסטים מודרניים, לטקסטים רבניים, לטקסטים שיריים ולכאלה שאינם כתובים לפי הכללים הנורמטיביים של העברית המודרנית.</p>
        <h3>סגנונות ניקוד</h3>
        <p>בחירת סגנון ניקוד - בחירה בין סגנון ניקוד מודרני, רבני או שירה.</p>
        <h3>עריכת ניקוד</h3>
        <p> כדי להתחיל בעבודת העריכה, עליכם להזין מלל לתיבת הטקסט וללחוץ על ״החל ניקוד״. המסך שיבוא לאחר מכן יכלול את הטקסט שלכם עם ניקוד אוטומטי.</p>
        <ol>
          <li>מילה במצב עריכה: צבע רקע תכלת.</li>
          <li>מילה שנערכה: צבע סגול.</li>
        </ol>
        <h3>כדי לבחור אפשרות ניקוד חלופית או כדי לערוך ידנית את הניקוד, יש ללחוץ על המילה הרצויה:</h3>
        <ol>
          <li>אפשרויות ניקוד אוטומטי: לכל מילה יינתנו מספר אפשרויות ניקוד חלופיות. כדי ליישם את האפשרות הרצויה, יש להקליק עליה וללחוץ על ״שמור שינויים״.
            <div class="pr-2">
              * פירוט מורפולוגי: כדי להקל על בחירת הניקוד הרצוי, אפשר להיעזר בהצגת הפירוט המורפולוגי לכל אפשרות ניקוד שמופיעה ברשימת האפשרויות. בלחיצה על 3 הנקודות שמופיעות לצד הכותרת של ״אפשרויות ניקוד״, אפשר יהיה להפעיל את האפשרות של הצגת פרוט מורפולוגי.            </div>
          </li>
          <li>
           ניקוד ידני: המילה שנבחרה מתוך הטקסט תופיע בצירוף מקלדת ניקוד. לחיצה על האות שתרצו לנקד, תציג במקלדת את הניקוד האפשרי לאותה אות.
            <div class="pr-2">
              * אימות קריאה: במקלדת יש אפשרות לסמן אות כאם קריאה, או להגדיר אותה חזרה כעיצור כשהסמן מוצב על האות.
            </div>
          </li>
        </ol>
        <h3>סרגל כלים</h3>
        <p>סרגל הכלים מופיע בחלק העליון של המסך:</p>
        <ol>
          <li>העתקה <span><i class="far fa-clone"></i></span></li>
          <li>שחזור פעולה / ביטול פעולה <span><i class="fas fa-share"></i>&nbsp;<i class="fas fa-reply"></i></span></li>
          <li>שיתוף של הטקסט המנוקד <span><i class="fas fa-share-alt"></i></span></li>
          <li>אפשרויות תצוגה נוספות, בלחיצה על 3 הנקודות שמופיעות בחלק העליון בצד שמאל. <span><i class="fas fa-ellipsis-v"></i></span>
            <ul>
              <li>הגדלה / הקטנה של הטקסט</li>
              <li>הצגת אימות קריאה</li>
            </ul>
          </li>
          <li>טעינת טקסט חדש, בלחיצה על החץ שמופיע בחלק העליון בצד ימין.</li>
        </ol>
        <p>הנקדן הוא כלי חינמי מבית דיקטה.</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'howPopup',
  props: ['value'],
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss">
  #mobile-how-modal{
     -webkit-overflow-scrolling: touch;
    .modal-dialog {
      margin: 0!important;
    }
    .modal-content {
      border-radius: 0!important;
      height: 100vh;
      overflow-y: scroll;
      overflow-x:hidden;
      background:white;
    }
  }
</style>
<style scoped lang="scss">
  h1{
   padding-top: 60px;font-size:24px;
  }
  h3{
    text-decoration: underline;
  }
.mobile-modal-top{
    height: 50px;
    padding:15px;
    position: fixed;
    width: 100%;
    z-index: 1;
    top: 0;
    right:0;
    h3{text-decoration:none;}
}
.how-to-inner-content{
    padding-top:50px;
    max-height: 87vh;
    overflow-y: scroll;
    overflow-x:hidden;
}
@media screen and (max-width: 667px) {
  .how-to-inner-content{
    max-height: 80vh;
  }
}
</style>
